import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const TargetRatingCapacityPage = () => {
  return(
    <HomeUI />
  )
}

export default TargetRatingCapacityPage;
